import { useEffect, useRef, useState } from 'react';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import styles from './AccordionOption/AccordionOption.module.scss';
import jsStyles from './AccordionOption/styles';

const acceptedBoxShadow =
  '0px -1px 4px 0px var(--color-gray-shadow), 0px 4px 0px 0px var(--color-light-green)';
const selectedBoxShadow =
  '0px -1px 4px 0px var(--color-gray-shadow), 0px 4px 0px 0px var(--color-main-orange)';

const CustomAccordion = withStyles(jsStyles.accordion)(Accordion);
const CustomAccordionSummary = withStyles(jsStyles.summary)(AccordionSummary);
const CustomAccordionDetails = withStyles(jsStyles.details)(AccordionDetails);

export default function AccordionFormField({
  selected,
  placeholder,
  onClick,
  formType,
  small,
  data,
}) {
  const accordionRef = useRef(null);
  const iconRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const header = (
    <span
      className={styles.header}
      style={{
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '16px',
        color:
          selected.text && !isExpanded
            ? 'var(--color-black)'
            : 'var(--color-light-gray-font)',
      }}
    >
      {selected.text && !isExpanded ? selected.text : placeholder}
    </span>
  );

  const handleSelectedItem = (item) => {
    setIsExpanded(false);
    onClick(item);
  };

  const handleAccordionChange = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (formType) {
      if (selected.text) {
        accordionRef.current.style['boxShadow'] = acceptedBoxShadow;
        iconRef.current.style['fill'] = 'var(--color-light-green)';
      } else {
        accordionRef.current.style['boxShadow'] = selectedBoxShadow;
        iconRef.current.style['fill'] = 'var(--color-main-orange)';
      }
    }
  }, [selected, formType]);

  return (
    <div style={{ ...jsStyles.container, margin: 0 }}>
      <span></span>
      <CustomAccordion
        ref={accordionRef}
        id="accordion"
        onChange={handleAccordionChange}
        expanded={isExpanded}
      >
        <CustomAccordionSummary
          expandIcon={
            <ExpandMoreIcon
              ref={iconRef}
              style={{ fill: 'var(--color-main-orange)' }}
            />
          }
        >
          <div className={styles.option__container}>{header}</div>
        </CustomAccordionSummary>
        <CustomAccordionDetails>
          <div
            className={
              small ? styles.listContainer_small : styles.listContainer
            }
          >
            {data.map((item, index) => (
              <div
                key={index}
                className={styles.option__container}
                onClick={() => handleSelectedItem(item)}
              >
                <div className={styles.option__text}>{item.text}</div>
              </div>
            ))}
          </div>
        </CustomAccordionDetails>
        <div style={{ height: '10px', marginBottom: '-10px' }}></div>
      </CustomAccordion>
      <span></span>
    </div>
  );
}
